import billingApiModule from '../billingApi.module';

class PayableApiService {
    constructor(__env, apiUtil, authenticationConstants) {
        this.__env = __env;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
    }

    getPayables() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/payables`
        );
    }
}

export default billingApiModule.service('payableApiService', PayableApiService);



// WEBPACK FOOTER //
// ./modules/billingApi/payable/payableApi.service.js